export default __webpack_public_path__ + "static/platforms-sm-8c86a7e89048f1b3a73774560b95350a.svg";